import { useEffect } from "react";
const ADSERVER_ID = process.env.REACT_APP_ADSERVER_ID;

export const useAdsRefresh = (stateIds) => {
    useEffect(() => {
        window.reviveAsync && window.reviveAsync[ADSERVER_ID].refresh();
        console.log("ads refresh !!");
    }, [stateIds]);
}